// Sticky mobile add-to-cart bar.
// - Reveals itself once the inline buy button scrolls out of view.
// - Forwards taps to the real (inline) add-to-cart button, which already holds
//   the selected variant id and is gated by global.js until every size is picked
//   (so we never duplicate the variant picker here).
//
// Loaded with `defer`, so the DOM is ready when this runs — no DOMContentLoaded.
(() => {
  const root = document.querySelector('[data-sticky-atc]');
  if (!root) return;

  const bar = root.querySelector('.fixed-bottom');
  const stickyButton = root.querySelector('#atc-btn-mobile');
  const inlineButton = document.querySelector('.bouton-atc');
  // The inline buy button: while it is on screen the sticky bar stays hidden.
  const anchor = document.querySelector('.product-form__buttons');
  if (!bar || !stickyButton || !inlineButton || !anchor) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  });
  observer.observe(anchor);

  stickyButton.addEventListener('click', () => inlineButton.click());
})();
